import { TaskStatus } from '@taraai/types';

export const mapTaskStatusToColor = {
  [TaskStatus.Todo]: '$todo',
  [TaskStatus.Doing]: '$focus',
  [TaskStatus.Done]: '$success',
  [TaskStatus.QA]: '$indigo',
} as const;
